import seoWidget from './4A-seoWidget.js';
import youtubeVideo from './4B-youtubeVideo.js';
import customSignup from './4C-customSignup.js';

export default function seoSection() {
  seoWidget();

  $(globalThis).on('load', function () {
    youtubeVideo();
  });

  customSignup();
}
